import { extend } from 'vee-validate'
import i18n from '../lang/admin/i18n'
import * as eaw from 'eastasianwidth'
import * as rules from 'vee-validate/dist/rules'

Object.keys(rules).forEach((rule) => {
  extend(rule, {
    ...rules[rule],
    message: (_, values) => i18n.t(`validations.${rule}`, values),
  })
})

extend('half_size', {
  validate(value) {
    const reg = new RegExp(/^[ -~ｦ-ﾟ]*$/)
    return {
      valid: reg.test(value),
    }
  },
  message: (_, values) => i18n.t('validations.half_size', values),
})

extend('alpha_number_under_score', {
  validate(value) {
    const reg = new RegExp(/^[0-9A-Z_]*$/i)
    return {
      valid: reg.test(value),
    }
  },
  message: (_, values) => i18n.t('validations.with_under_score', values),
})

extend('full_half_size', {
  params: ['size'],
  validate(value, { size }) {
    return {
      valid: eaw.length(value) <= size,
    }
  },
  message: (_, values) => {
    values['full_size'] = parseInt(values.size) / 2
    return i18n.t('validations.full_half_size', values)
  },
})

extend('number_alphabet_character', {
  validate(value) {
    const reg = new RegExp(
      //eslint-disable-next-line
      /^[a-zA-Z0-9\'@`!"#$%&\'()*+,-.\/:;[{<¥|=\]}>\^~?_]*$/
    )
    return {
      valid: reg.test(value),
    }
  },
  message: (_, values) =>
    i18n.t('validations.number_alphabet_character', values),
})

extend('combined_two_character', {
  validate(value) {
    //eslint-disable-next-line
    const regNumberAlphabet = new RegExp('^(?=.*[a-zA-Z])(?=.*[0-9])')
    const regNumberCharacter = new RegExp(
      //eslint-disable-next-line
      "^(?=.*[0-9])(?=.*['@`!\"#$%&\\'()*+,-.\\/:;[{<¥|=\\]}>\\^~?_])"
    )
    const regAlphabetCharacter = new RegExp(
      //eslint-disable-next-line
      "^(?=.*[a-zA-Z])(?=.*['@`!\"#$%&\\'()*+,-.\\/:;[{<¥|=\\]}>\\^~?_])"
    )
    return {
      valid:
        regNumberAlphabet.test(value) ||
        regNumberCharacter.test(value) ||
        regAlphabetCharacter.test(value),
    }
  },
  message: (_, values) => i18n.t('validations.combined_two_character', values),
})

extend('email', {
  validate(value) {
    const reg = new RegExp(
      //eslint-disable-next-line
      /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    )
    return {
      valid: reg.test(value),
    }
  },
  message: (_, values) => i18n.t('validations.email', values),
})

extend('full_size_katakana', {
  validate(value) {
    const reg = new RegExp(/^[ァ-ンヴー・。ヽヾ、]*$/)
    return {
      valid: reg.test(value),
    }
  },
  message: (_, values) => i18n.t('validations.full_size_katakana', values),
})

extend('full_size', {
  validate(value) {
    // const reg = new RegExp(/^[\x3040-\x309F\x30A0-\x30FF\x3400-\x4DB5\x4E00-\x9FCB\xF900-\xFA6A]*$/);
    return {
      valid: value.length * 2 == eaw.length(value),
    }
  },
  message: (_, values) => i18n.t('validations.full_size', values),
})

extend('half_size_number', {
  params: ['lang'],
  validate(value) {
    return !isNaN('' + value)
  },
  message: (_, values) => {
    let { lang } = values
    if (lang != undefined) {
      return i18n.t(lang)
    }
    return i18n.t('validations.half_size_number', values)
  },
})
export default {}
